import React, { useEffect, useState, useMemo } from "react";
import "../style/page/banner.scss";
import Button from "@mui/material/Button";
import BasicTable from "../maincomponent/reacttable/table";
import axios from "axios";
import { bannervideo } from "../../text/apidata";
import { useNavigate } from "react-router-dom";
import BannerFormVideo from "../form/bannerformvideo";
import { useSelector, useDispatch } from "react-redux";
import {
  symptoms,
  symptomsid,
  videobannerstate,
  videobannerid,
  sidebar,
} from "../redux/reducer/counterslice";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import SymptomsForm from "../form/symptomsform";
function BannerVideo(props) {
  const [tableheaderdata, settableheaderdata] = useState([]);
  const [age, setAge] = React.useState();
  const [datacount, setdatacount] = useState();
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const dispatch = useDispatch();
  const symid = useDispatch();
  const sideactive = useSelector((state) => state.counter.sidebarnav);
  const symptomsedit = useSelector((state) => state.counter.videobannerstate);
  const [popup, setpopup] = useState(false);
  const [id, setid] = useState();
  const [isactivefilterdata, setisactivefilterdata] = useState("");

  // console.log(dtpageindex,"0889")
  const dropdownhandlechange = (e) => {
    if (e) {
      dispatch(videobannerstate("banneredit"));
      symid(videobannerid(e));
    }
  };

  const deletebanner = (e) => {
    setid(e);
    setpopup(true);
  };
  useEffect(() => {
    if (searchQuery != "") {
      const hasNumbers = /[0-9]/.test(searchQuery);
      const hasLetters = /[a-zA-Z]/.test(searchQuery);
      const hasSpecialChars = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\-]/.test(
        searchQuery
      );
      if (hasNumbers || hasLetters || hasSpecialChars) {
        props.loaderchange("true");
        axios({
          method: "get",
          url: bannervideo,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
          params: {
            page: dtpageindex,
            page_size: dtpagesize,
            search: searchQuery,
            is_active: isactivefilterdata,
          },
        })
          .then((res) => {
            console.log(res.data, res.data.data_count, "table");

            settableheaderdata(res.data.data);
            setdatacount(res.data.data_count);
            props.loaderchange("false");
          })
          .catch((error) => {
            console.log(error);
            props.loaderchange("false");
            // setdtPageindex(dtpageindex-1)
            // console.log(dtpageindex)
            props.popupalert("true");
            props.popuptext("No Data Available");
            setTimeout(() => {
              props.popupalert("false");
            }, 2000);
          });
      }
    } else {
      props.loaderchange("true");
      axios({
        method: "get",
        url: bannervideo,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
        params: {
          page: dtpageindex,
          page_size: dtpagesize,
          search: searchQuery,
          is_active: isactivefilterdata,
        },
      })
        .then((res) => {
          console.log(res.data, res.data.data_count, "table");

          settableheaderdata(res.data.data);
          setdatacount(res.data.data_count);
          props.loaderchange("false");
        })
        .catch((error) => {
          console.log(error);
          props.loaderchange("false");
          // setdtPageindex(dtpageindex-1)
          // console.log(dtpageindex)
          props.popupalert("true");
          props.popuptext("No Data Available");
          setTimeout(() => {
            props.popupalert("false");
          }, 2000);
        });
    }
  }, [dtpageindex, dtpagesize, searchQuery, symptomsedit, isactivefilterdata]);
  const columns = useMemo(
    () => [
      // {
      //   Header: "Image Url",
      //   accessor: "",
      //   Cell: (row) => {
      //     return (
      //       <>
      //         {row.row.original.file_type == "video/mp4" ? (
      //           <span>
      //             <div>
      //               {/* <img src={row.row.original.file_url} style={{borderRadius:"50%",width:"50px",height:"50px"}}></img> */}
      //               <video muted autoplay controls>
      //                 <source
      //                   src={row.row.original.file_url}
      //                   type="video/mp4"
      //                 ></source>
      //               </video>
      //             </div>
      //           </span>
      //         ) : (
      //           <span>
      //             <div>
      //               <img
      //                 src={row.row.original.file_url}
      //                 style={{
      //                   // borderRadius: "50%",
      //                   // width: "50px",
      //                   // height: "50px",
      //                   width: "230px",
      //                   height: "139px",
      //                   margin: "10px",
      //                 }}
      //               ></img>
      //             </div>
      //           </span>
      //         )}
      //       </>
      //     );
      //   },
      // },

      {
        Header: "Banner Name",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.speciality)
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="symptoms"
                  data-tooltip-content={String(row.row.original.banner_name)}
                >
                  {String(row.row.original.banner_name)}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Display Order",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="symptoms"
                  data-tooltip-content={row.row.original.display_order}
                >
                  {row.row.original.display_order}
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Youtube Link",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.speciality)
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="symptoms"
                  data-tooltip-content={String(
                    row.row.original.file_url != null
                      ? row.row.original.file_url
                      : "--"
                  )}
                >
                <a target="_blank" href={row.row.original.file_url==null?"/":row.row.original.file_url}>
                  {String(
                    row.row.original.file_url != null
                      ? row.row.original.file_url.slice(0,34)+"..."
                      : "--"
                  )}
                  </a>
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Landing URL",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.speciality)
          return (
            <>
              <span>
                <div
                  style={{ marginTop: "3px" }}
                  data-tooltip-id="symptoms"
                  data-tooltip-content={String(
                    row.row.original.landing_url != null
                      ? row.row.original.landing_url
                      : "--"
                  )}
                >
                <a target="_blank" href={row.row.original.landing_url==null?"/":row.row.original.landing_url}>
                  {String(
                    row.row.original.landing_url != null
                      ? row.row.original.landing_url
                      : "--"
                  )}
                  </a>
                </div>
              </span>
            </>
          );
        },
      },
      {
        Header: "Active",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original.username)
          return (
            <>
              <p
                data-tooltip-id="my-tooltip"
                data-tooltip-content={
                  row.row.original.is_active == false ? "No" : "Yes"
                }
              >
                {row.row.original.is_active == false ? (
                  <p style={{ color: "red", fontWeight: 700 }}>No</p>
                ) : (
                  <p style={{ color: "green", fontWeight: 700 }}>Yes</p>
                )}
              </p>
            </>
          );
        },
      },

      {
        Header: "Actions",
        accessor: "",
        Cell: (row) => {
          // console.log(row.row.original)
          //settablevalue(row.row.original)

          return (
            <>
              <div class="actions">
                <button
                  type="button"
                  class="btn btn-danger btn-sm edit"
                  onClick={(e) => dropdownhandlechange(row.row.original.id, e)}
                >
                  <i class="bi bi-pencil-fill"></i> Edit
                </button>
                <button
                  type="button"
                  class="btn btn-danger btn-sm delete"
                  onClick={(e) => deletebanner(row.row.original.id, e)}
                >
                  <i class="bi bi-trash3"></i> Delete
                </button>
              </div>
            </>
          );
        },
      },
    ],
    []
  );

  const creatfunction = (e) => {
    dispatch(videobannerstate("createbanner"));
  };

  const pagesize = (arg) => {
    // alert(arg);
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
  };
  const loaderchangechild = (arg) => {
    // console.log(arg,"jkh")
    props.loaderchange(arg);
  };
  const popupalertchild = (arg) => {
    props.popupalert(arg);
  };
  const popuptextchild = (arg) => {
    props.popuptext(arg);
  };
  const confirm = () => {
    props.loaderchange("true");
    axios({
      method: "delete",
      url: bannervideo + id + "/",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token") + "",
      },
    })
      .then((res) => {
        console.log(res.data);
        // window.location.href = "/Banner";
        setpopup(false);

        window.location.reload();

        props.loaderchange("false");

        props.popupalert("true");
        props.popuptext("Data Deleted Successfully");
        setTimeout(() => {
          props.popupalert("false");
        }, 2000);
      })
      .catch((error) => {
        console.log(error);
        props.loaderchange("false");
        // setdtPageindex(dtpageindex-1)
        // console.log(dtpageindex)
        props.popupalert("true");
        props.popuptext("No Data Available");
        setTimeout(() => {
          props.popupalert("false");
        }, 2000);
      });
  };
  return (
    <>
      <div
        className={sideactive ? "maincontainer_ban-sa" : "maincontainer_ban"}
      >
        <div className="patient-header">
          <div className="row">
            <div className="col">
              <h3 className="page-title">Banner Videos</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <a
                    href="/"
                    style={{ textDecoration: "none", color: "black" }}
                    onClick={(e) => {
                      dispatch(sidebar("DashBoard"));
                    }}
                  >
                    Dashboard
                  </a>
                </li>
                <li className="breadcrumb-item active">
                  Banner Videos
                </li>
              </ul>
            </div>
            <div class="col-sm-5 col">
              <a
                onClick={(e) => creatfunction(e)}
                style={{
                  backgroundColor: "#1b5a90",
                  border: "1px solid #1b5a90",
                  color: "white",
                }}
                data-toggle="modal"
                class="btn btn-primary float-right mt-2"
              >
                Add
              </a>
            </div>
          </div>
        </div>
        <div className="row" style={{ marginTop: 20 }}>
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="Banner">
                  <div className="table-content-Banner">
                    <form onSubmit={handleSubmit}>
                      {/* <TextField
                        id="search-bar"
                        className="text"
                        onInput={(e) => {
                          setSearchQuery(e.target.value);
                        }}
                        // onKeyDown={(e)=>test2(e)}
                        label="Search"
                        variant="outlined"
                        placeholder="Search..."
                        size="small"
                        inputProps={{ autoComplete: "off" }}
                      /> */}
                      <div
                        class="input-group rounded"
                        style={{ width: "250px", height: "40px" }}
                      >
                        <input
                          type="search"
                          class="form-control rounded"
                          aria-label="Search"
                          aria-describedby="search-addon"
                          value={searchQuery}
                          onKeyDown={(e) => {
                            if (e.target.value.length === 0 && e.which === 32) {
                              e.preventDefault();
                            }
                          }}
                          onInput={(e) => {
                            if (e.target.value.length <= "100") {
                              setSearchQuery(e.target.value);
                            } else {
                              e.preventDefault();
                            }
                          }}
                          min="0"
                          max="10"
                          label="Search"
                          placeholder="Search..."
                          required
                        />
                        <span
                          class="input-group-text border-0 bg-transparent"
                          id="search-addon"
                        >
                          <i
                            class="bi bi-search"
                            style={{
                              color: "#1b5a90",
                              width: "20px",
                              height: "20px",
                            }}
                          ></i>
                        </span>
                      </div>
                    </form>

                    <div className="table-Symptoms">
                      <BasicTable
                        columns={columns}
                        data={tableheaderdata}
                        pagesize={pagesize}
                        pageindex={pageindex}
                        dtpagesize={dtpagesize}
                        dtpageindex={dtpageindex}
                        datacount={datacount}
                        isactive={true}
                        isactivefilterdata={isactivefilterdata}
                        setisactivefilterdata={setisactivefilterdata}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ReactTooltip
          id="symptoms"
          arrowColor="transparent"
          place="bottom-start"
          delayShow={200}
          style={{
            backgroundColor: "#707070",
            fontSize: "10px",
            textAlign: "center",
            padding: "5px",
            fontWeight: 400,
          }}
        />
      </div>
      {symptomsedit == "banneredit" || symptomsedit == "createbanner" ? (
        <>
          <BannerFormVideo
            loaderchange={loaderchangechild}
            popupalert={popupalertchild}
            popuptext={popuptextchild}
          />
        </>
      ) : (
        ""
      )}
      {popup && (
        <>
          <div className="logout_popup">
            <div class="container1">
              <div class="cookiesContent" id="cookiesPopup">
                <button
                  class="close"
                  onClick={(e) => {
                    setpopup(false);
                  }}
                >
                  ✖
                </button>
                {/* <img src={logoutimg} alt="cookies-img" /> */}
                <p style={{ marginTop: "20px" }}>
                  Do You Want to Delete the Data?
                </p>
                <div style={{ display: "flex" }}>
                  <button class="accept p-2 m-2" onClick={(e) => confirm()}>
                    Yes!
                  </button>
                  <button
                    class="accept p-2 m-2"
                    onClick={(e) => setpopup(false)}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default BannerVideo;
